import getCookie from "../func/getCookie";
import { create } from "zustand";

const initialState = {
  loading: false,
  success: false,
  error: false,
  errorData: null,
  emailTemplateParam: new URL(window.location.href)?.searchParams.get("email_template"),
  emailTemplateCookie: getCookie("email_template"),
  orderHashParam: new URL(window.location.href)?.searchParams.get("order"),
  orderHashCookie: getCookie("orderHash"),
  freeShippingApplied: false,
  freeShippingEnabled: window.freeShippingEnabled,
  remainingTime: window.freeShippingRemainingTime,
};

export const useMarketingStore = create((set, get) => ({
  ...initialState,
  setFreeShippingApplied: (payload) => {
    set((state) => ({
      ...state,
      freeShippingApplied: payload,
    }));
  },
}));
